import React from 'react';
import { useParams, useSearchParams, Navigate } from 'react-router-dom';
import { IssueCategory } from './types';

const VALID_CATEGORIES: IssueCategory[] = ['JOB', 'MATCHING', 'APPLY', 'OTHER'];

const isValidCategory = (category: string | undefined): category is IssueCategory => {
    return category !== undefined && VALID_CATEGORIES.includes(category as IssueCategory);
};

interface ValidCategoryGuardProps {
    children: React.ReactNode;
}

/**
 * Route guard that validates the category URL parameter.
 * Redirects to category selection page if the category is invalid.
 */
const ValidCategoryGuard: React.FC<ValidCategoryGuardProps> = ({ children }) => {
    const { category } = useParams<{ category: string }>();
    const [searchParams] = useSearchParams();

    return isValidCategory(category) ? (
        <>{children}</>
    ) : (
        <Navigate
            to={{
                pathname: '/auto-apply-setup/report-issue',
                search: searchParams.toString(),
            }}
            replace
        />
    );
};

export default ValidCategoryGuard;
